package or.garden.manager.ui.utils

fun getCropImageSource(icon: String?): String? {
    if (icon == null) return null
    val key = icon.lowercase()
    val basePath = "composeResources/gardenmanager.composeapp.generated.resources/drawable"
    
    return when (key) {
        "tomato" -> "$basePath/tomato.webp"
        "cucumber" -> "$basePath/cucumber.webp"
        "courgette", "zucchini" -> "$basePath/courgette.webp"
        "lettuce" -> "$basePath/lettuce.webp"
        "onion" -> "$basePath/onion.webp"
        "potato" -> "$basePath/potato.webp"
        "carrot" -> "$basePath/carrot.webp"
        "celery" -> "$basePath/celery.webp"
        "beetroot" -> "$basePath/beetroot.webp"
        "cabbage" -> "$basePath/cabbage.webp"
        "broccoli" -> "$basePath/broccoli.webp"
        "pea" -> "$basePath/pea.webp"
        "radish" -> "$basePath/radish.webp"
        "chard" -> "$basePath/chard.webp"
        "parsley" -> "$basePath/parsley.webp"
        "cauliflower" -> "$basePath/cauliflower.webp"
        "corn" -> "$basePath/corn.webp"
        "turnip" -> "$basePath/turnip.webp"
        "leek" -> "$basePath/leek.webp"
        "cherry_tomatoes" -> "$basePath/cherry_tomatoes.webp"
        "pepper" -> "$basePath/pepper.webp"
        "eggplant" -> "$basePath/eggplants.webp"
        "beans", "board_beans" -> "$basePath/board_beans.webp"
        "spinach" -> "$basePath/spinach.webp"
        "strawberry" -> "$basePath/strawberry.webp"
        "basil" -> "$basePath/basil.webp"
        "marigold" -> "$basePath/marigold.webp"
        "calendula" -> "$basePath/calendula.webp"
        "sunflower" -> "$basePath/sunflower.webp"
        "chives" -> "$basePath/chives.webp"
        "coriander" -> "$basePath/coriander.webp"
        "pumpkin" -> "$basePath/pumpkin.webp"
        "garlic" -> "$basePath/garlic.webp"
        "kale" -> "$basePath/kale.webp"
        "okra" -> "$basePath/okra.webp"
        "sweet_potato" -> "$basePath/sweet_potato.webp"
        "ai" -> "$basePath/ai.webp"
        else -> null
    }
}
